import React, { useState } from "react";
import { validateEmail } from "./helpers";
import Field from "./Field";
import { BrandButton, Spinner } from "../../assets";
import { useSelector, useDispatch } from "react-redux";
import { login, setSessionData } from "../../actions/session";

export default function EmailLogin() {

	const dispatch = useDispatch();
	const { loading, loginError, query } = useSelector(state => state.session);
	const { forEmailConfirmation } = query;

	const [values, setValues] = useState({});
	const [fieldErrors, setFieldErrors] = useState({});

	function fieldChange({ name, value, error }) {
		setValues({
			...values,
			[name]: value
		});
		setFieldErrors({
			...fieldErrors,
			[name]: error
		});
	}

	return <form key="email-login" onSubmit={e => {
		e.preventDefault();
		dispatch(setSessionData({ query: { ...query, forEmailConfirmation: false } }));
		dispatch(login(values));
	}}>
		{forEmailConfirmation ? <h4>Great! Now you just have to sign in.</h4> : <h4>Log in with email</h4>}
		<br />
		<Field
			onChange={fieldChange}
			name="email"
			values={values}
			errors={fieldErrors}
			autoComplete="email"
			placeholder="Email"
			validate={validateEmail}
		/>
		<Field
			onChange={fieldChange}
			name="password"
			type="password"
			values={values}
			errors={fieldErrors}
			autoComplete="current-password"
			placeholder="Password"
		/>
		<BrandButton
			type="submit"
			disabled={loading || Object.values(fieldErrors).filter(e => e).length}
		>{loading ? <Spinner size={24} /> : "Log In"}</BrandButton>
		{loginError && <>
			<br />
			<div className="error text-center">
				{loginError}
			</div>
		</>}
	</form>
}